import { alpha, Theme } from '@mui/material/styles';
import { glassPrintSurface } from '../glass';

// ----------------------------------------------------------------------

export default function Table(theme: Theme) {
  return {
    MuiTableContainer: {
      styleOverrides: {
        root: {
          position: 'relative',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: theme.palette.action.selected,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: 'none',
          '@media print': {
            ...glassPrintSurface(theme),
          },
        },
        body: {
          '@media print': {
            ...glassPrintSurface(theme),
          },
        },
        head: {
          color: theme.palette.text.secondary,
          backgroundColor: alpha(theme.palette.background.neutral, theme.palette.mode === 'light' ? 0.5 : 0.38),
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          '@media (prefers-reduced-transparency: reduce)': {
            backgroundColor: alpha(theme.palette.background.neutral, 0.96),
            backdropFilter: 'none',
            WebkitBackdropFilter: 'none',
          },
          '@media print': {
            ...glassPrintSurface(theme),
          },
        },
        stickyHeader: {
          backgroundColor: alpha(theme.palette.background.paper, theme.palette.mode === 'light' ? 0.66 : 0.5),
          backgroundImage: 'none',
          '@media (prefers-reduced-transparency: reduce)': {
            backgroundColor: alpha(theme.palette.background.paper, 0.96),
          },
          '@media print': {
            ...glassPrintSurface(theme),
          },
        },
        paddingCheckbox: {
          paddingLeft: theme.spacing(1),
        },
      },
    },
    MuiTablePagination: {
      defaultProps: {
        backIconButtonProps: {
          size: 'small',
        },
        nextIconButtonProps: {
          size: 'small',
        },
        SelectProps: {
          MenuProps: {
            MenuListProps: {
              sx: {
                '& .MuiMenuItem-root': {
                  ...theme.typography.body2,
                },
              },
            },
          },
        },
      },

      styleOverrides: {
        root: {
          borderTop: `solid 1px ${theme.palette.divider}`,
        },
        toolbar: {
          height: 64,
        },
        actions: {
          marginRight: theme.spacing(1),
        },
        select: {
          '&:focus': {
            borderRadius: theme.shape.borderRadius,
          },
        },
      },
    },
  };
}
